// extracted by mini-css-extract-plugin
export var indeterminate = "_1g-5";
export var md = "_1g-4";
export var semantic = "_1g-6";
export var sm = "_1g-3";
export var text = "_1g-7";
export var toggleInput = "_1g-0";
export var toggleSwitch = "_1g-1";
export var xs = "_1g-2";